module.exports = __webpack_public_path__ + "img/Pierced_Butterfly.c11e350e.png";